const TimeFormatter = {

  toHoursMinutesFormat: minutes => {
    if (!minutes || minutes <= 0) {
      return null
    }
    if (minutes < 60) {
      return `${minutes}m`
    }
    if (minutes % 60) {
      return `${Math.floor(minutes / 60)}h ${minutes % 60}m`
    }
    return `${minutes / 60}h`
  }

}

export default TimeFormatter



// WEBPACK FOOTER //
// ./src/infra/TimeFormatter.js